"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iGoogleLocation = exports.iAutocompleteData = exports.iGoogleLocationPartial = exports.iCoordinates = void 0;
const t = require("io-ts");
exports.iCoordinates = t.interface({
    lat: t.number,
    lng: t.number
});
exports.iGoogleLocationPartial = t.interface({
    googlePlaceId: t.string,
    description: t.string
});
exports.iAutocompleteData = t.interface({
    description: t.string,
    place_id: t.string
});
exports.iGoogleLocation = t.intersection([
    exports.iGoogleLocationPartial,
    exports.iCoordinates
]);
//# sourceMappingURL=location.js.map